import React from "react";
import { Col, Row } from "react-bootstrap";
export default function MapDetail(props) {
  const { page } = props;
  console.log("page ", page);
  return (
    <div className="coRe-detail">
      <div id="box" style={{ width: "100%", marginRight: 10 }}>
        <div className="wrap-collabsible">
          <input
            id="collapsible"
            className="toggle"
            type="checkbox"
            defaultChecked="true"
            style={{ pointerEvents: "auto", display: "none" }}
          />
          <label
            htmlFor="collapsible"
            className="lbl-toggle label-detail-map"
            style={{ pointerEvents: "auto" }}
          >
            รายละเอียด
          </label>

          <div className="collapsible-content">
            <div className="content-inner">
              <Row>
                <Col xs={4} style={{ textAlign: "center" }}>
                  <img
                    className="img-detail-map"
                    src="https://researcher.kims-rmuti.com/icon/res@300x.png"
                    alt="res-logo"
                  />
                </Col>
                <Col xs={8}>
                  <p style={{ textAlign: "left" }}>งานวิจัย</p>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={4} style={{ textAlign: "center" }}>
                  <img
                    className="img-detail-map"
                    src="https://researcher.kims-rmuti.com/icon/AS.jpg"
                    alt="res-logo"
                  />
                </Col>
                <Col xs={8}>
                  <p style={{ textAlign: "left" }}>งานบริการวิชาการ</p>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={4} style={{ textAlign: "center" }}>
                  <img
                    className="img-detail-map"
                    src="https://researcher.kims-rmuti.com/icon/U2T.jpg"
                    alt="res-logo"
                  />
                </Col>
                <Col xs={8}>
                  <p style={{ textAlign: "left" }}>
                    โครงการบริการวิชาการ (U2T)
                  </p>
                </Col>
              </Row>

              {page === "knowledge" ? (
                <>
                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/knowledge3(1).png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>องค์ความรู้เดิม</p>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/innovation2.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>นวัตกรรม</p>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/new%20knowledge3.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>องค์ความรู้ใหม่</p>
                    </Col>
                  </Row>
                </>
              ) : page === "goal" ? (
                <>
                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/BCG.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>BCG</p>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/SDGs-icon.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>SDGs</p>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        style={{ width: "35px" }}
                        src="https://researcher.kims-rmuti.com/icon/10S-curve.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>10s-curve</p>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        style={{ width: "35px" }}
                        src="https://researcher.kims-rmuti.com/icon/RMUTI-Cluster.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>RMUTI Cluster</p>
                    </Col>
                  </Row>
                </>
              ) : page === "impact" ? (
                <>
                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/Economy-impact.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>เศรษฐกิจ</p>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/New-Social-impact.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>สังคม</p>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/Cultural-impact.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>วัฒนธรรม</p>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/Environmental-impact.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>สิ่งแวดล้อม</p>
                    </Col>
                  </Row>
                </>
              ) : page === "newknowledge" ? (
                <>
                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/innovation2.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>นวัตกรรม</p>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col xs={4} style={{ textAlign: "center" }}>
                      <img
                        className="img-detail-map"
                        src="https://researcher.kims-rmuti.com/icon/new%20knowledge3.png"
                        alt="res-logo"
                      />
                    </Col>
                    <Col xs={8}>
                      <p style={{ textAlign: "left" }}>องค์ความรู้ใหม่</p>
                    </Col>
                  </Row>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
